const NS = 'SiteFooterGrowerToolsWidget';
const CLS = 'siteFooterGrowerToolsWidget';

export class SiteFooterGrowerToolsWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.toolsBtn = this.$element.find(`.${CLS}-toolsBtn`);
		this.toolsBtnIcon = this.toolsBtn.find(`.${CLS}-toolsBtn-icon`);
		this.tools = this.$element.find(`.${CLS}-tools`);

		this.toolsBtn.on('click', () => {
			if(!this.tools.hasClass(`${CLS}-tools--active`)) {
				this.tools.addClass(`${CLS}-tools--active`);
				this.toolsBtnIcon.removeClass('icon--chevron-sm-right');
				this.toolsBtnIcon.addClass('icon--chevron-sm-down');
			}
			else {
				this.tools.removeClass(`${CLS}-tools--active`);
				this.toolsBtnIcon.addClass('icon--chevron-sm-right');
				this.toolsBtnIcon.removeClass('icon--chevron-sm-down');
			}
		});
	}
}
